import { ListSubheader, ListSubheaderProps } from '@mui/material';
import React from 'react';

const ListSubheaderWrapper: React.FC<ListSubheaderProps> = (props) => <ListSubheader {...props} />;

export default ListSubheaderWrapper;
